import { Appearance, Price, ProductReference, ProductType, ProductTypeSize, View } from '@/types';
import { getParams, isEmbroideryMode } from '@/utils/params';

const getEditLink = () => {
  const editLinkBase =
    getParams().editBasketItemUrl ||
    `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  const separator = /\?(.*)/.test(editLinkBase) ? '&' : '?';
  return `${editLinkBase}${separator}basketId={BASKET_ID}&basketItemId={BASKET_ITEM_ID}${
    isEmbroideryMode() ? '&embroidery=true' : ''
  }`;
};

export const createExternalBasketPayload = (
  productReference: ProductReference,
  appearance: Appearance,
  productType: ProductType,
  view: View,
  size: ProductTypeSize,
  quantity: number,
  price: Price
) => {
  return {
    product: productReference,
    quantity,
    price,
    appearance: {
      id: appearance.id,
      name: appearance.name,
    },
    view: { id: view.id, name: view.name },
    productType: {
      id: productType.id,
      name: productType.name,
    },
    size: {
      id: size.id,
      name: size.name,
    },
    editLink: getEditLink(),
    shopId: getParams().contextId,
    embroidery: isEmbroideryMode() || false,
  };
};
